module.exports = __webpack_public_path__ + "static/2020新消费增长企业榜单top50-5226df7c5fdb382b5a923105836a14b6.jpg";